import { message, Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updateAccountDetails } from "Sdk/Actions";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";

export const CustomTheme = ({ isCustomThemeOpen, setIsCustomThemeOpen }) => {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [selectedThemeId, setselectedThemeId] = useState(null);
  const userDetails = useSelector(getUserDetailsFromReducer);
  const [customTheme, setCustomTheme] = useState({
    background: "#E6E6E6",
    text: "#333C4D",
    btnBg: "#333C4D",
    btnText: "#ffffff",
  });

  const themePalettes = [
    // Light themes (first 15)
    {
      id: 0,
      themecolor: {
        background: "#E6E6E6",
        text: "#333C4D",
        btnBg: "#333C4D",
        btnText: "#ffffff",
      },
    },
    {
      id: 1,
      themecolor: {
        background: "#F7F7FF",
        text: "#2A2A40",
        btnBg: "#5F6CAF",
        btnText: "#fff",
      },
    },
    {
      id: 2,
      themecolor: {
        background: "#F5E6E8",
        text: "#222",
        btnBg: "#B8C1EC",
        btnText: "#232946",
      },
    },
    {
      id: 3,
      themecolor: {
        background: "#F9F9F9",
        text: "#22223B",
        btnBg: "#9A8C98",
        btnText: "#fff",
      },
    },
    {
      id: 4,
      themecolor: {
        background: "#F0EDEE",
        text: "#232946",
        btnBg: "#B8C1EC",
        btnText: "#232946",
      },
    },
    {
      id: 5,
      themecolor: {
        background: "#F6D365",
        text: "#222",
        btnBg: "#FDA085",
        btnText: "#222",
      },
    },
    {
      id: 6,
      themecolor: {
        background: "#FFDEE9",
        text: "#232946",
        btnBg: "#B5FFFC",
        btnText: "#232946",
      },
    },
    {
      id: 7,
      themecolor: {
        background: "#FCEABB",
        text: "#232946",
        btnBg: "#F8B500",
        btnText: "#232946",
      },
    },
    {
      id: 8,
      themecolor: {
        background: "#FFB347",
        text: "#232946",
        btnBg: "#FFCC33",
        btnText: "#232946",
      },
    },
    {
      id: 9,
      themecolor: {
        background: "#F7971E",
        text: "#fff",
        btnBg: "#FFD200",
        btnText: "#232946",
      },
    },
    {
      id: 10,
      themecolor: {
        background: "#BFE9FF",
        text: "#232946",
        btnBg: "#FF6E7F",
        btnText: "#fff",
      },
    },
    {
      id: 11,
      themecolor: {
        background: "#E0EAFC",
        text: "#2B2E4A",
        btnBg: "#A1C4FD",
        btnText: "#2B2E4A",
      },
    },
    {
      id: 12,
      themecolor: {
        background: "#FFF1EB",
        text: "#485563",
        btnBg: "#ACE0F9",
        btnText: "#485563",
      },
    },
    {
      id: 13,
      themecolor: {
        background: "#F8FFAE",
        text: "#43C6AC",
        btnBg: "#FFF6B7",
        btnText: "#43C6AC",
      },
    },
    {
      id: 14,
      themecolor: {
        background: "#F3E7E9",
        text: "#C471F5",
        btnBg: "#F9F9F9",
        btnText: "#C471F5",
      },
    },
    // Dark themes (next 15)
    {
      id: 15,
      themecolor: {
        background: "#232946",
        text: "#eebbc3",
        btnBg: "#b8c1ec",
        btnText: "#232946",
      },
    },
    {
      id: 16,
      themecolor: {
        background: "#22223B",
        text: "#fff",
        btnBg: "#9A8C98",
        btnText: "#fff",
      },
    },
    {
      id: 17,
      themecolor: {
        background: "#16161E",
        text: "#FCFCFF",
        btnBg: "#ff9300",
        btnText: "#000000",
      },
    },
    {
      id: 18,
      themecolor: {
        background: "#1A1A1A",
        text: "#F5F5F5",
        btnBg: "#FF5733",
        btnText: "#F5F5F5",
      },
    },
    {
      id: 19,
      themecolor: {
        background: "#2D3142",
        text: "#BFC0C0",
        btnBg: "#EF8354",
        btnText: "#fff",
      },
    },
    {
      id: 20,
      themecolor: {
        background: "#222",
        text: "#fff",
        btnBg: "#00C896",
        btnText: "#222",
      },
    },
    {
      id: 21,
      themecolor: {
        background: "#0F2027",
        text: "#fff",
        btnBg: "#2C5364",
        btnText: "#fff",
      },
    },
    {
      id: 22,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#414345",
        btnText: "#fff",
      },
    },
    {
      id: 23,
      themecolor: {
        background: "#283E51",
        text: "#fff",
        btnBg: "#485563",
        btnText: "#fff",
      },
    },
    {
      id: 24,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#FF512F",
        btnText: "#fff",
      },
    },
    {
      id: 25,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#3A6073",
        btnText: "#fff",
      },
    },
    {
      id: 26,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#11998E",
        btnText: "#fff",
      },
    },
    {
      id: 27,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#FC5C7D",
        btnText: "#fff",
      },
    },
    {
      id: 28,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#00B4DB",
        btnText: "#fff",
      },
    },
    {
      id: 29,
      themecolor: {
        background: "#232526",
        text: "#fff",
        btnBg: "#F7971E",
        btnText: "#fff",
      },
    },
    // Add a custom palette option
    {
      id: -1,
      themecolor: customTheme,
      custom: true,
    },
  ];

  const handleUpdateCustomTheme = useCallback(async () => {
    try {
      let customThemeStringified = JSON.stringify(selectedTheme);
      const userData = {
        username: userDetails.username,
        themeColor: customThemeStringified,
      };
      await updateAccountDetails(userData);
      message.success("Theme Updated Successfully!");
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    }
  }, [selectedTheme, userDetails.username, message]);

  const handleThemeSelect = (id) => {
    if (id === -1) {
      setSelectedTheme(customTheme);
      setselectedThemeId(-1);
    } else {
      const selectedPalette = themePalettes.find((palette) => palette.id === id);
      if (selectedPalette) {
        setSelectedTheme(selectedPalette.themecolor);
        setselectedThemeId(id);
      } else {
        console.error("Theme not found for ID:", id);
      }
    }
  };

  useEffect(() => {
    // Only update theme if a theme is actually selected (not null)
    if (selectedTheme) {
      handleUpdateCustomTheme();
    }
  }, [selectedTheme, handleUpdateCustomTheme]);

  return (
    <Modal open={isCustomThemeOpen} onCancel={() => setIsCustomThemeOpen(false)} footer={null} title="Select Theme">
      <div className="overflow-x-auto p-5">
        <div className="grid gap-4 md:grid-cols-4 grid-cols-2">
          {themePalettes.map((palette) => (
            <div
              key={palette.id}
              className={`p-2 border-2 rounded-lg cursor-pointer ${
                selectedThemeId === palette.id ? "border-blue-500" : "border-gray-300"
              }`}
              onClick={() => handleThemeSelect(palette.id)}
            >
              <div className="flex rounded-md w-full overflow-hidden">
                <div className="h-10 w-full" style={{ backgroundColor: palette.themecolor.background }}></div>
                <div className="h-10 w-full" style={{ backgroundColor: palette.themecolor.text }}></div>
                <div className="h-10 w-full" style={{ backgroundColor: palette.themecolor["btnBg"] }}></div>
                <div className="h-10 w-full" style={{ backgroundColor: palette.themecolor["btnText"] }}></div>
              </div>
              {palette.custom && <div className="text-center mt-2 text-xs font-semibold">Custom</div>}
            </div>
          ))}
        </div>
        {/* Show color pickers if custom is selected */}
        {selectedThemeId === -1 && (
          <div className="mt-6 flex flex-col gap-4 items-center">
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <label className="text-xs mb-1">Background</label>
                <input
                  type="color"
                  value={customTheme.background}
                  onChange={(e) =>
                    setCustomTheme({
                      ...customTheme,
                      background: e.target.value,
                    })
                  }
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-xs mb-1">Text</label>
                <input
                  type="color"
                  value={customTheme.text}
                  onChange={(e) => setCustomTheme({ ...customTheme, text: e.target.value })}
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-xs mb-1">Button BG</label>
                <input
                  type="color"
                  value={customTheme.btnBg}
                  onChange={(e) => setCustomTheme({ ...customTheme, btnBg: e.target.value })}
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="text-xs mb-1">Button Text</label>
                <input
                  type="color"
                  value={customTheme.btnText}
                  onChange={(e) => setCustomTheme({ ...customTheme, btnText: e.target.value })}
                />
              </div>
            </div>
            <button
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold"
              onClick={() => setSelectedTheme(customTheme)}
            >
              Save Custom Theme
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};
